import { render, staticRenderFns } from "./CustomersIndex.vue?vue&type=template&id=1ad097bc&scoped=true"
import script from "./CustomersIndex.vue?vue&type=script&lang=js"
export * from "./CustomersIndex.vue?vue&type=script&lang=js"
import style0 from "./CustomersIndex.vue?vue&type=style&index=0&id=1ad097bc&prod&lang=scss&scoped=true"
import style1 from "./CustomersIndex.vue?vue&type=style&index=1&id=1ad097bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad097bc",
  null
  
)

export default component.exports